// Types
import HistoryTime from 'components/HistoryTime';
// Utils
import { getText } from 'i18n/intl';
import _ from 'lodash';
import { EPaddingRuleType } from '@timeedit/types/lib/enums';
import type { TPaddingRule } from '@timeedit/types/lib/types';
// Components
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

export interface PaddingRuleInfoProps {
  paddingRule: TPaddingRule & { includeAbstractObjects?: boolean };
  onChange: (key: string, value: any) => void;
}

const PaddingRuleInfo = (props: PaddingRuleInfoProps) => {
  const { paddingRule, onChange } = props;
  return (
    <TEDrawerSection label="General info">
      <div className="section-col">
        <TEInput.Select
          label="Padding type"
          tooltip="Padding type"
          value={paddingRule.paddingType}
          options={Object.values(EPaddingRuleType).map((paddingType) => ({
            value: paddingType,
            label: getText(paddingType),
          }))}
          onChange={(val) => onChange('paddingType', val)}
          data-testid="padding-type"
        />
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={paddingRule.name}
          onChange={(val) => onChange('name', val)}
          placeholder="New padding rule"
          data-testid="padding-name"
        />
        <TEInput.Switch
          label="Include abstract object"
          tooltip="Include abstract object"
          checked={paddingRule.includeAbstractObjects}
          onChange={(val) => onChange('includeAbstractObjects', val)}
          data-testid="include-abstract-objects"
        />
        <TEInput.TextArea
          label="Description"
          tooltip="Description"
          value={paddingRule.description}
          onChange={(val) => onChange('description', val)}
          data-testid="padding-desc"
        />
      </div>
      <HistoryTime history={paddingRule?.history} />
    </TEDrawerSection>
  );
};

export default PaddingRuleInfo;
